import React from "react";
import LoadingSpinner from "views/Components/loadingSpinner";

const ResourceState = ({ resource, emptyText, children }) => {
  if (resource.loading)
    return <div className="cw-inline-loading"><LoadingSpinner /></div>;
  if (resource.error)
    return <div className="cw-tab-error" role="alert">{resource.error}</div>;
  if (!resource.data || !resource.data.data || !resource.data.data.length)
    return <p className="cw-muted cw-empty-state">{emptyText}</p>;
  return children;
};

export default ResourceState;
